/**
 * Cookiebot JS controller.
 */

class Cookiebot {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.closeButton = document.getElementById("CybotCookiebotBannerCloseButtonE2E");
    }

    /**
     * Remove the close button from the cookie banner because of accessibility issues.
     */
    removeCloseButton() {
        if (this.closeButton) {
            this.closeButton.remove();
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.removeCloseButton();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/cookiebot.js